<template>
  <FormContainer @submitForm="saveFinanziamento">
    <div class="row">
      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Nome del finanziamento"
        v-model="finanziamento.name"
        :errorMsg="errorHash['name']"
        @input="removeError('name')"
      />

      <FormInputAmountWidget
        class="col-lg-4 col-sm-6"
        label="Importo"
        v-model.number="finanziamento.importo"
        :errorMsg="errorHash['importo']"
        @input="removeError('importo')"
        :min="0"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Tasso"
        v-model.number="finanziamento.tasso"
        :errorMsg="errorHash['tasso']"
        @input="removeError('tasso')"
      />

      <FormInputSelectWidget
        class="col-lg-4 col-sm-6"
        label="Tipo di piano"
        v-model="finanziamento.tipoPianoId"
        :options="tipoPianoOptions"
      />

      <FormInputSelectWidget
        class="col-lg-4 col-sm-6"
        label="Frequenza rate"
        v-model="finanziamento.frequenzaRate"
        :options="frequenzaRateOptions"
      />

      <FormInputIntegerWidget
        class="col-lg-4 col-sm-6"
        label="Numero rate ammortamento"
        v-model.number="finanziamento.nbRate"
        :errorMsg="errorHash['nbRate']"
        @input="removeError('nbRate')"
      />

      <FormInputIntegerWidget
        not-required
        class="col-lg-4 col-sm-6"
        label="Numero rate preammortamento"
        v-model.number="finanziamento.nbRatePreammortamento"
        :errorMsg="errorHash['nbRatePreammortamento']"
        @input="removeError('nbRatePreammortamento')"
      />

      <FormInputMonthPickerWidget
        class="col-lg-4 col-sm-6"
        label="Data erogazione"
        v-model="finanziamento.erogazione"
        :errorMsg="errorHash['erogazione']"
        @input="removeError('erogazione')"
      />

      <FormInputMonthPickerWidget
        class="col-lg-4 col-sm-6"
        label="Mese prima scadenza ammortamento"
        v-model="finanziamento.primaScadenza"
        :errorMsg="errorHash['primaScadenza']"
        @input="removeError('primaScadenza')"
      />

      <FormInputMonthPickerWidget
        not-required
        class="col-lg-4 col-sm-6"
        label="Mese prima scadenza preammortamento"
        v-model="finanziamento.primaScadenzaPreammortamento"
      />
    </div>

    <div class="row">
      <div class="col-12 mt-4 text-center text-sm-right">
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-save mr-2"></i>
          Salva finanziamento
        </button>
      </div>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';

export default {
  name: 'operative-form-cost',
  mixins: [validateMixin],
  components: {
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputIntegerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputIntegerWidget'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
    FormInputPercentageWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputPercentageWidget'),
    FormInputSelectWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputSelectWidget'),
    FormInputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget'),
  },
  props: {
    finanziamento: {
      type: Object,
      default: () => ({
        name: null,
        importo: null,
        tasso: 0,
        tipoPianoId: 1,
        frequenzaRate: null,
        nbRate: 12,
        nbRatePreammortamento: 0,
        erogazione: null,
        primaScadenza: null,
        primaScadenzaPreammortamento: null,
      }),
    },
    tipoPianoOptions: {
      type: Array,
      default: () => [
        { value: 1, label: 'Francese' },
        { value: 2, label: 'Italiano' },
      ],
    },
    frequenzaRateOptions: {
      type: Array,
      default: () => [
        { value: 1, label: 'Mensile' },
        { value: 2, label: 'Bimensile' },
        { value: 3, label: 'Trimestrale' },
        { value: 4, label: 'Semestrale' },
        { value: 5, label: 'Annuale' },
      ],
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    validate () {
      this.clearErrors();

      if (!this.finanziamento.name) {
        this.addError('Il nome del finanziamento è obbligatorio', 'name');
      }

      if (!this.finanziamento.importo) {
        this.addError('L\'importo del finanziamento è obbligatorio', 'importo');
      }

      if (!this.finanziamento.tasso && this.finanziamento.tasso !== 0) {
        this.addError('Il tasso è obbligatorio', 'tasso');
      }

      if (!this.finanziamento.nbRate) {
        this.addError('Il numero di rate è obbligatorio', 'nbRate');
      }

      if (!this.finanziamento.erogazione) {
        this.addError('Il mese di erogazione è obbligatorio', 'erogazione');
      }

      if (!this.finanziamento.primaScadenza) {
        this.addError('Il mese della prima scadenza è obbligatorio', 'primaScadenza');
      }

      return !this.hasErrors;
    },

    saveFinanziamento () {
      if (!this.validate()) {
        return;
      }

      this.$emit('saved', this.finanziamento);
    },
  },
};

</script>
